import { render, staticRenderFns } from "./TentangKami.vue?vue&type=template&id=662ef819&scoped=true&"
import script from "./TentangKami.vue?vue&type=script&lang=js&"
export * from "./TentangKami.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "662ef819",
  null
  
)

export default component.exports